import { useIntl } from 'react-intl';
import { IconSchool, IconSchoolOff } from '@rossum/ui/icons/tabler';
import { Stack, SvgIcon, Tooltip } from '@rossum/ui/material';
import { GridRenderCellParams } from '@rossum/ui/x-data-grid-pro';
import { SnakeCaseStatus } from '../../../types/annotationStatus';

type TrainingStatusRow = {
  training_enabled?: boolean;
  status: SnakeCaseStatus;
};

const isDeletedOrPurged = (status: SnakeCaseStatus) =>
  status === 'deleted' || status === 'purged';

export const RenderTrainingStatus = ({
  row,
}: GridRenderCellParams<TrainingStatusRow>) => {
  const intl = useIntl();

  // Deleted/purged documents are never included in training regardless of the API value
  const isTrainingEnabled = isDeletedOrPurged(row.status)
    ? false
    : (row.training_enabled ?? true);

  const tooltipText = intl.formatMessage({
    id: isTrainingEnabled
      ? 'components.documentOverview.trainingStatus.enabled'
      : 'components.documentOverview.trainingStatus.disabled',
  });

  return (
    <Stack
      alignItems="center"
      justifyContent="center"
      width="100%"
      height="100%"
      color="text.disabled"
    >
      <Tooltip title={tooltipText} placement="top">
        <SvgIcon fontSize="medium" data-cy="training-status-icon">
          {isTrainingEnabled ? <IconSchool /> : <IconSchoolOff />}
        </SvgIcon>
      </Tooltip>
    </Stack>
  );
};
